<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->
<template>
  <div class="animated fadeIn" v-if="base">
    <vcl-facebook v-if="loading"></vcl-facebook>
      <List v-show="list && !loading" ref="list" @loading="(status) => loading = status" />
      <Detail v-if="detail && !list" @refresh="refresh" @loading="(status) => loading = status" />
  </div>
</template>

<script>

import List from './Detect.List.i18n';
import Detail from './Detect.Detail.i18n';
import { VclFacebook } from 'vue-content-loading';

export default {
  components: { List, Detail, VclFacebook },
  data: () => ({ base: true, list: false, detail: false, loading : true }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.children.forEach(ch => ch.refresh()) } },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = false); }
      else { this.detail = !(this.list = false); }
      this.base = true
    }
  },
  created: function() {   console.log('detect.vue', 'created'); },
  destroyed: function() { console.log('detect.vue', 'destroyed'); },
  mounted: function() {
    console.log('detect.vue', 'mounted');
    this.select(this.$route.params);
  },
  watch: {
    '$route' (to, from) {
      console.log('detect.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
}
</script>
